import type { ChatMessageView } from "web_myplann/Chat/Types/chatMessage";

export const getChatMessageKey = (message: ChatMessageView) =>
	message.clientId ?? String(message.id);
